import { IBranch, IBranchList, IRecentlyOrderedBranch } from '../types/Branch';

export const getBranch = (item?: IBranch) => ({
  _id: item?._id ?? '',
  title: item?.title ?? '',
  address: item?.address ?? '',
  delivery_available: item?.delivery_available ?? false,
  location: {
    lon: item?.location?.lon ?? 0,
    lat: item?.location?.lat ?? 0,
  },
  contacts: {
    phone_number: item?.contacts?.phone_number ?? '',
  },

  working_hours: {
    monday: item?.working_hours?.monday ?? '',
    tuesday: item?.working_hours?.tuesday ?? '',
    wednesday: item?.working_hours?.wednesday ?? '',
    thursday: item?.working_hours?.thursday ?? '',
    friday: item?.working_hours?.friday ?? '',
    saturday: item?.working_hours?.saturday ?? '',
    sunday: item?.working_hours?.sunday ?? '',
  },
  distance: item?.distance ?? 0,
});

export const branchesAdapter = (data?: IBranch[]) =>
  data?.map(item => getBranch(item)) ?? [];

//  - - - - - - - -  - - - - -  -- - - - - - - - - -  - - - - - - - -

export const getBranchesList = (item?: IBranchList) => ({
  id: item?.id ?? 0,
  title: item?.title ?? '',
  address: item?.address ?? '',
  iiko_id: item?.iiko_id ?? '',
  long: item?.long ?? '',
  lat: item?.lat ?? '',
  phone: item?.phone ?? '',
  working_hours: item?.working_hours ?? '',
  tags:
    item?.tags?.map(tag => ({
      id: tag?.id ?? 0,
      title: tag?.title ?? '',
    })) ?? [],
  banners:
    item?.banners?.map(banner => ({
      id: banner?.id ?? 0,
      image: banner?.image ?? '',
      title: banner?.title ?? '',
    })) ?? [],
});

export const branchesListAdapter = (data?: IBranchList[]) =>
  data?.map(item => getBranchesList(item)) ?? [];

//  - - - - - - - -  - - - - -  -- - - - - - - - - -  - - - - - - - -

// Only the branch ids are trustworthy here — the endpoint's own fields
// (no phone/working_hours, combined lat/lng) are too thin to render a full
// branch card, so callers cross-reference these ids against `/branch/list`.
export const recentlyOrderedBranchIdsAdapter = (
  data?: IRecentlyOrderedBranch[]
) => data?.map(item => item.id) ?? [];
